export const GET_ROYALTIES_EDITOR = "GET_ROYALTIES_EDITOR"
export const GET_ROYALTIES_SUCCESS = "GET_ROYALTIES_SUCCESS"
export const GET_ROYALTIES_ERROR = "GET_ROYALTIES_ERROR"

